import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["error", "existingAbbreviation", "field", "input", "submitButton"];
  static values = { currentAbbreviation: String };

  disableSubmit () {
    this.submitButtonTarget.disabled = true;
  }

  checkUniqueness () {
    this.clearValidationError();

    const abbreviation = this.normalize(this.inputTarget.value);
    if (abbreviation.length !== 4 || !this.takenAbbreviations.includes(abbreviation)) return;

    this.fieldTarget.classList.add("field_with_errors");
    this.errorTarget.textContent = `${abbreviation} has already been taken`;
    this.errorTarget.classList.remove("hidden");
  }

  get takenAbbreviations () {
    // Setting a company abbreviation is rare enough not to require real-time server checks.
    // Uniqueness is still checked by the server on final submission.
    const currentAbbreviation = this.normalize(this.currentAbbreviationValue);

    return this.existingAbbreviationTargets
      .map(element => this.normalize(element.textContent))
      .filter(abbreviation => abbreviation !== currentAbbreviation);
  }

  clearValidationError () {
    this.fieldTarget.classList.remove("field_with_errors");
    this.fieldTarget.querySelectorAll(".field_with_errors").forEach(element => {
      element.classList.remove("field_with_errors");
    });
    this.fieldTarget.querySelectorAll(".error.ts-input__help").forEach(element => {
      if (element !== this.errorTarget) element.remove();
    });
    this.errorTarget.textContent = "";
    this.errorTarget.classList.add("hidden");
  }

  normalize (abbreviation) {
    return abbreviation.trim().toUpperCase();
  }
}
